<ng-container *ngIf="order; else showSpinner">
  <!-- CTAs on top of component -->
  <ng-container *ngIf="cancelOrdersAllowed && (hasItemEditable || allItemsEditable) && !isOrderClosed">
    <div class="cancel-items-cta">
      <button
        class="btn secondary-btn"
        *ngIf="hasItemEditable"
        [disabled]="consignmentEntryControl.invalid"
        (click)="toggleCancelEditModal('cancel-selected-items')"
      >
        {{ 'myAccount.orderDetails.cancelSelected' | cxTranslate }}
      </button>
      <button class="btn secondary-btn" *ngIf="allItemsEditable" (click)="toggleCancelEditModal('cancel-order')">
        {{ 'myAccount.orderDetails.cancelOrder' | cxTranslate }}
      </button>
    </div>
  </ng-container>
  <!-- Consignment -->
  <mat-selection-list [formControl]="consignmentEntryControl" class="p-0">
    <div class="order-entry" *ngFor="let consignment of order.consignments">
      <div class="consignment-status" [ngClass]="activeCountry$ | async">
        @if (features?.showCreditOrderConsignmentStatus && consignment?.statusCode === consignmentsStatus.SHIPPED) {
        <div class="status status-icon">
          {{ 'myAccount.orderDetails.consignmentSummary.status.returnOrder' | cxTranslate }}
        </div>
        } @else {
        <div class="status status-icon">
          <mat-icon [svgIcon]="getStatusIcon(consignment?.statusCode)"></mat-icon>
          {{ consignment?.statusDisplay }}({{ consignment.entries.length }})
        </div>
        }
        <div
          class="download"
          *ngIf="
            (isDownloadInvoiceEnabled$ | async) && consignment?.invoice && consignment?.invoice?.downloadLink !== ''
          "
        >
          <a
            [href]="consignment?.invoice?.downloadLink"
            download=""
            rel="noopener noreffer"
            target="_blank"
            type="application/octet-stream"
          >
            <span class="alt-text">{{
              'myAccount.orderDetails.consignmentSummary.status.downloadInvoice' | cxTranslate
            }}</span>
            <mat-icon class="light" svgIcon="exportfile"></mat-icon>
          </a>
        </div>
        <div
          class="tracking"
          *ngIf="
            (isDownloadTrackAndTraceEnabled$ | async) &&
            consignment?.trackingLink?.length &&
            !features?.hideTrackAndTrace
          "
        >
          <cx-generic-link [url]="consignment?.trackingLink" target="_blank">
            <span class="alt-text">{{
              'myAccount.orderDetails.consignmentSummary.status.trackAndTrace' | cxTranslate
            }}</span>
            <mat-icon class="light" svgIcon="track"></mat-icon>
          </cx-generic-link>
        </div>
        <div class="delivery-group" *ngIf="consignment?.shippingAddress?.formattedAddress?.length">
          <div class="label">{{ 'myAccount.orderDetails.consignmentSummary.status.deliveryLabel' | cxTranslate }}</div>
          <div class="value" [innerHTML]="showAddress(consignment?.shippingAddress) | async"></div>
        </div>
        <div class="delivery-group delivery-date" *ngIf="consignment?.deliveryDate?.length">
          <div class="label" [innerHTML]="getDeliveryDateLabelKey(consignment?.statusCode) | cxTranslate"></div>
          <div *ngIf="consignment?.statusCode !== consignmentsStatus.BACKORDER" class="value">
            {{ consignment?.deliveryDate | date : dateFormat() }}
          </div>
        </div>
        <div
          class="delivery-group tracking-id"
          *ngIf="(isTrackingIdEnabled$ | async) && consignment?.trackingID?.length"
        >
          <div class="label">{{ 'myAccount.orderDetails.consignmentSummary.status.trackingId' | cxTranslate }}</div>
          <app-tooltip-text
            class="tracking-id-value"
            [tooltipContent]="consignment?.trackingID"
            [content]="consignment?.trackingID"
            placement="bottom"
          ></app-tooltip-text>
        </div>
      </div>
      <!-- Consignment Entry -->
      <div class="consignment-entry">
        <ng-container *ngFor="let item of consignment.entries; let i = index; let last = last">
          <hr class="line-summary" />
          <div
            class="entry"
            [class.entry-overlay]="
              item.orderEntry?.changesPending || consignment?.statusCode === consignmentsStatus.CANCELLED
            "
          >
            <ng-container *ngIf="cancelOrdersAllowed && showCancelEditCTA(item, consignment?.statusCode)">
              <mat-list-option
                class="entry-checkbox"
                [value]="item.orderEntry"
                [disabled]="item.orderEntry?.changesPending"
              ></mat-list-option>
            </ng-container>
            <div class="image">
              <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: item.orderEntry.product } | cxUrl">
                <cx-media
                  [container]="
                    item.orderEntry?.product?.images
                      ? getImageRendition((item.orderEntry?.product?.images)[0])
                      : { src: 'https://via.placeholder.com/72' }
                  "
                  format="product"
                  [class.is-missing-fish]="businessType === 'fish'"
                ></cx-media>
              </a>
            </div>
            <div class="entry-info">
              <div class="code">{{ item?.orderEntry?.product?.code }}</div>
              <div class="name">
                <a
                  class="cx-link"
                  [routerLink]="{ cxRoute: 'product', params: item.orderEntry.product } | cxUrl"
                  [innerHTML]="item?.orderEntry?.product?.name"
                ></a>
              </div>
              <div class="global-variant" *ngIf="item?.orderEntry?.product?.superCategories">
                <ng-container
                  *ngFor="
                    let variant of checkVariant(item?.orderEntry?.product?.superCategories);
                    let index = index;
                    let last = last
                  "
                >
                  <ng-container *ngIf="!last; else lastItem"
                    >{{ variant.parentCategoryName }}: {{ variant.name }};
                  </ng-container>
                  <ng-template #lastItem>{{ variant.parentCategoryName }}: {{ variant.name }}</ng-template>
                </ng-container>
              </div>
              <div
                class="lead-time"
                *ngIf="item?.orderEntry?.leadTime && consignment?.statusCode === consignmentsStatus.BACKORDER"
              >
                {{ 'cart.cartItem.delivery.value.days' | cxTranslate : { time: item?.orderEntry?.leadTime } }}
              </div>
            </div>
            <div
              class="lead-time-tablet"
              *ngIf="item?.orderEntry?.leadTime && consignment?.statusCode === consignmentsStatus.BACKORDER"
            >
              {{ 'cart.cartItem.delivery.value.days' | cxTranslate : { time: item?.orderEntry?.leadTime } }}
            </div>
            <div
              class="entry-price"
              [class.longQtyTextPL]="longQtyText(activeCountry$ | async, activeLanguage$ | async)"
            >
              <div class="dealer-price">
                <div class="label" *ngIf="!showSrp">{{ 'cart.cartItem.itemPrice' | cxTranslate }}</div>
                <div class="value" *ngIf="!showSrp">
                  <ng-container *ngIf="isActiveCountrySSSC$ | async; else dealerPriceReady">
                    <div
                      class="spinner-shimano-wrapper-dp"
                      *ngIf="!dealerPrice(item?.orderEntry?.product?.code); else dealerPriceReady"
                    >
                      <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                        <div class="spinner-shimano" *ngIf="hasDealerPrice">
                          <div class="spinner-shimano-mt-ml"></div>
                        </div>
                        <div
                          class="no-dealer-price no-dealer-price-cs-cm"
                          *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                        ></div>
                        <ng-template #noDealerPriceTooltip>
                          <app-tooltip-icon
                            *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled"
                            [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                            dealerPriceIconContainerClass="no-dealer-price-cs-cm"
                            placement="bottom-right"
                            [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                            [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                          ></app-tooltip-icon>
                        </ng-template>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #dealerPriceReady>
                    {{ item?.orderEntry?.product?.price?.formattedValue
                    }}<span
                      class="gst-label"
                      *ngIf="item?.orderEntry?.product?.price?.formattedValue && showGstExclusive$ | async"
                      >{{ 'gst.exclusive' | cxTranslate }}</span
                    >
                  </ng-template>
                </div>
              </div>
              <div class="qty">
                <div class="label" *ngIf="(isCustomTranslationsEnabled$ | async) !== null">
                  {{
                    'cart.cartItem.quantity'
                      | cxTranslate
                        : {
                            context: setCustomContext(
                              isCustomTranslationsEnabled$ | async,
                              activeCountry$ | async,
                              activeLanguage$ | async
                            )
                          }
                  }}
                </div>
                <div class="value">
                  {{ item?.orderEntry?.quantity }}
                </div>
              </div>
              <div class="total">
                <div class="label" *ngIf="!showSrp">{{ 'cart.cartItem.total' | cxTranslate }}</div>
                <div class="value" *ngIf="!showSrp">
                  <b>{{ item?.orderEntry?.totalPrice?.formattedValue }}</b>
                  <span
                    class="gst-label"
                    *ngIf="item?.orderEntry?.totalPrice?.formattedValue && showGstInclusive$ | async"
                    >{{ 'gst.inclusive' | cxTranslate }}</span
                  >
                </div>
              </div>
            </div>
            <!-- CTAs per item line -->
            <ng-container *ngIf="showCancelEditCTA(item, consignment?.statusCode)">
              <div class="entry-cta">
                <button
                  type="button"
                  *ngIf="editOrdersAllowed"
                  (click)="toggleCancelEditModal('edit-item-qty', item.orderEntry, getEditItemModalData(item))"
                >
                  <mat-icon svgIcon="edit"></mat-icon>
                </button>
                <button
                  class="entry-cta-cancel"
                  type="button"
                  *ngIf="cancelOrdersAllowed"
                  (click)="toggleCancelEditModal('cancel-selected-items', item.orderEntry)"
                >
                  <mat-icon svgIcon="modal-x-icon"></mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <hr class="line-summary" />
      <div class="consignment-total">
        <div class="label">
          <b>{{ 'cart.cartItem.total' | cxTranslate }}</b
          ><span class="gst-label" *ngIf="showGstInclusive$ | async">{{
            'gst.inclusive' | cxTranslate : { context: 'parenthetical' }
          }}</span>
        </div>
        <div class="value" *ngIf="!showSrp">
          <b>{{ consignment?.totalPrice?.formattedValue }}</b>
        </div>
      </div>
    </div>
  </mat-selection-list>
</ng-container>
<ng-template #showSpinner>
  <div class="results-spinner">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
</ng-template>
